import React, { useEffect } from 'react';
import MissingTimeReportDataTable from './MissingTimeReportDataTable';

const MissingTimeReportIndex = ({ rrhh, resource }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <MissingTimeReportDataTable rrhh={rrhh} resource={resource} />;
};

export default MissingTimeReportIndex;
